import {useEffect, useState} from 'react'
/**
 * There are 2 items, one permanentStore and the other is the prices. 
 * The permanentStore contains all the records from the file - like a source of truth but converted from excel to json format.
 * Items contains the filtered version based on the startRow and endRow and is what will be shown in the table.
 * @returns items, setPermanentStore, setRowStart, setRowEnd
 */
export const useExcelUpload = () => {
    const [items, setItems] = useState([])
    const [permanentStore, setPermanentStore] = useState([])
    const [rowStart, setRowStart] = useState()
    const [rowEnd, setRowEnd] = useState() 

    useEffect(()=>{
      
     // console.log("Here are the items", items)
    },[items])

    useEffect(()=>{
      //Splice excludes it
        if(rowStart && rowEnd){
          const items = permanentStore.slice((rowStart-1), (rowEnd))
          setItems(items)
        }
        else if(!rowStart && rowEnd){
          const items = permanentStore.slice(0, (rowEnd))
          setItems(items)
        }
        else if(rowStart && !rowEnd){
          const items = permanentStore.slice((rowStart-1), permanentStore.length)
          setItems(items)
        }
        else{
          setItems(permanentStore)
        }
    },[permanentStore, rowStart, rowEnd])

    return {items, setPermanentStore, setRowStart, setRowEnd}
}
